<template>
  <div class="about">
    <!-- 照片 -->
    <div class="photo_outer">
        <div class="photo">
           <img src="https://images.36w.cn/officialWebImagse/about/pic_banner01@2x.png"/>
        </div>
    </div>
    <!-- 公司介绍 -->
    <div class="box1980_outer companyProfile_outer" id="boxCenter">
        <div class="box1980 companyProfile">
            <img class="img1 animated" src="https://images.36w.cn/officialWebImagse/img_floating_circle@3x.png"/>
            <img class="img2 animated" src="https://images.36w.cn/officialWebImagse/about/bg03@2xs.png"/>
            <h2 class="subhead" style="padding-top:62px;">公司介绍</h2>
            <div class="companyProfileContent">
               <div class="companyProfileContentImg">
                 <!-- <img src="https://images.36w.cn/officialWebImagse/pic_thecompany_photos@3x.png"/> -->
               </div>
               <div class="companyProfileContentText">
                  <div class="textContent">
                     <div class="paragraph paragraphUp">
                         <p>位来小猎成立于2018年1月，管理团队分别来自于华为、智联招聘、中智、中华英才网、阿里等行业领先企业，拥有十年以上的人力资源经验，具备丰富的人力资源专业知识和项目实践，曾服务众多500强企业和知名互联网公司。</p>
                         <p>位来小猎聚焦于人力资源行业的人力资源全风险外包服务、灵工用工共享平台结算业务、集约SSC中心的筹建服务。</p>
                     </div>
                     <div class="paragraph paragraphDown">
                         <p>位来小猎聚焦行业精英，利用后发优势，在3年内成为行业黑马公司，服务于众多的新经济领域的头部客户，伴随他们的成长和扩张，其中包括字节跳动、小米、网易、美团、SHEIN等新经济公司，同时服务于其他行业客户，如物美集团、满记甜品、国家体育总局等各行业的领军企业。</p>
                         <p>目前开设了北京、上海、深圳、杭州、青岛、宁波、西安、大连、安徽、海南、邯郸等12家分公司，业务覆盖100+城市，拥有员工300+，以及近10000名在岗外包员工。</p>
                     </div>
                  </div>
               </div>
            </div>
        </div>
    </div>
    <!-- 公司愿景 -->
    <div class="outer vision_outer">
      <div class="inside vision">
          <div class="vision_modular">
              <h4>公司愿景</h4>
              <p>伴随中国城市化进程，让每一位求职者获得更多的尊严和幸福</p>
          </div>
          <div class="vision_modular">
              <h4>公司使命</h4>
              <p>更有效率地帮助每一位求职者找到合适的工作，并不断提升职业竞争力</p>
          </div>
          <div class="vision_modular">
              <h4>价值观</h4>
              <p>以客户为中心，以奋斗者为本，把求职者的未来当作自己的未来</p>
          </div>
      </div>
    </div>
    <!-- 发展历程 -->
    <div class="box1980_outer developmentHistory_outer" id="boxCenter2">
        <div class="box1980 developmentHistory">
           <h2 class="subhead" style="padding-top:91px;color:#fff">发展历程</h2>
           <div class="developmentHistoryContent">
               <div class="contentLeft fl">
                   <div class="record" v-for="(item,index) in development2018" :key="index">
                       <h4 v-if="index == 0 ">2018年</h4>
                       <p :style="index != 0 ?'margin-top:37px':''">{{item.text}}</p>
                   </div>
                   <div style="margin-top:105px;">
                      <div class="record" v-for="(item,index) in development2020" :key="index">
                          <h4 v-if="index == 0 " style="padding-left:168px;">2020年</h4>
                          <p :style="index != 0 ?'margin-top:36px':''">{{item.text}}</p>
                      </div>
                   </div>
               </div>
               <div class="contentCenter-timeAxis fl">
                  <ul>
                      <li v-for="(i,index) in 12" :key="index">
                          <span></span>
                      </li>
                  </ul>
               </div>
               <div class="contentRight fl">
                  <div style="margin-top:189px;">
                    <div class="record" v-for="(item,index) in development2019" :key="index">
                        <h4 v-if="index == 0 ">2019年</h4>
                        <p :style="index != 0&&index != 2 ?'margin-top:37px':index == 2?'margin-top:37px':''">{{item.text}}</p>
                    </div>
                  </div>
                  <div style="margin-top:125px;">
                    <div class="record" v-for="(item,index) in development2021" :key="index">
                        <h4 v-if="index == 0 ">2021年</h4>
                        <p :style="index != 0&&index != 2 ?'margin-top:37px':index == 2?'margin-top:62px':''">{{item.text}}</p>
                    </div>
                  </div>
               </div>
           </div>
        </div>
    </div>
    <!-- 认证和荣誉 -->
    <div class="outer authentication_outer">
        <div class="inside authentication">
           <h2 class="subhead" style="padding-top:62px">证书和荣誉</h2>
           <div class="authenticationContent">
                <ul class="cl">
                    <li v-for="(i,index) in honorList" :key="index">
                       <div class="honorbox">
                         <img :src="i.imgurl"/>
                         <p>{{i.name}}</p>
                       </div>
                    </li> 
                </ul>
            </div>
        </div>
    </div>
      <!-- 员工风采 -->
    <div class="staff_outer">
        <div class="box1980 staff">
           <p class="subhead2" style="padding-top:73px;color: #fff;">员工风采</p>
           <div class="staffContent">
            <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" style="background:#ffffff">
                  <img src="https://images.36w.cn/officialWebImagse/img_staffstyle01.png"/>
                  <span>季度管理会</span>
                </div>
                <div class="swiper-slide" style="background:#ffffff">
                   <img src="https://images.36w.cn/officialWebImagse/img_staffstyle02.png"/>
                   <span>员工靓照</span>
                </div>
                <div class="swiper-slide" style="background:#ffffff">
                   <img src="https://images.36w.cn/officialWebImagse/img_staffstyle03.png"/>
                   <span>优秀员工颁奖典礼</span>
                </div>
                <div class="swiper-slide" style="background:#ffffff">
                   <img src="https://images.36w.cn/officialWebImagse/img_staffstyle04.png"/>
                   <span>节日PARTY</span>
                </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="borderbox">
              <div class="swiper-pagination"></div>
            </div>
          </div>
           </div>
        </div>
    </div>
    <!-- 联系我们 -->
    <div class="contactus_outer box1980_outer" id="boxCenter3">
        <div class="contactus box1980">
            <h2 class="subhead" style="padding-top:50px">联系我们</h2>
            <div class="contactusContent">
                <ul class="cl nav_ul">
                    <li @click="contactusNav(item.id)" :class="item.id == contactusActive?'contactusAcitve':''" v-for="(item,index) in cityData" :key="index">{{item.name}}</li>
                </ul>
                <ul class="cl content_ul">
                    <li v-for="(item,index) in cityData" :key="index">
                        <div v-if="item.id == contactusActive" class="content_ul_map">
                          <img class="img100" :src="mapimg" alt="" />
                           <!-- <img class="img100" :src="item.picture" alt="" /> -->
                           <!-- <bdmap :countryname="item.companyName" :address="address" :iphone="iphone" :lng="lng" :lat="lat" /> -->
                        </div>
                        <div v-if="item.id == contactusActive" class="content_ul_text">
                            <h3>{{item.title}}</h3>
                            <p>{{item.companyName}}<span>{{item.address}}</span><span>{{item.route}}</span></p>
                            <p>{{item.iphone}}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";
import bdmap from '../../util/bdmap.vue'
export default {
  data() {
    return {
      development2018: [
        { text: "1月，位来小猎成立" },
        { text: "2月，获得近千万天使轮融资" },
        { text: "9月，宁波分公司成立" },
        {
          text: "10月，基于社交裂变的微信小程序“入职有赏”上线，一个月内用户突破10万+",
        },
      ],
      development2019: [
        { text: "5月，小猎人外包管理系统上线" },
        { text: "6月，完成数千万Pre-A轮融资" },
        { text: "6月，获得8项软件著作权登记证书" },
        { text: "10月，成立邯郸分公司" },
        { text: "10月，惠有活灵活用工系统上线" },
        { text: "12月，成立青岛分公司" },
      ],
      development2020: [
        { text: "4月，成立深圳分公司" },
        { text: "9月，成立杭州分公司" },
        { text: "9月，通过国家高新技术企业认证" },
        { text: "10月，成立西安分公司" },
        { text: "12月，成立上海分公司" },
      ],
      development2021: [
        { text: "8月，通过了质量管理体系（ISO9001）和信息安全管理（ISO27001）体系认证" },
      ],
      contactusActive: 0,
        lng:'116.473955',
        lat:'39.965577',
        cityname:'北京位来小猎科技有限公司',
        address:'北京市朝阳区霄云路甲26号海航大厦8层',
        iphone:'400-603-0166',
        mapimg:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_beijing%402x.png",
      cityData: [
        {
          id: 0,
          name: "北京",
          address: "北京市朝阳区霄云路甲26号海航大厦8层",
          iphone: "400-603-0166",
          companyName: "北京位来小猎科技有限公司",
          title: "北京（总部）",
          route:'交通路线：地铁10号线三元桥站下车，C2口出',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_beijing%402x.png",
          lng:116.473955,
          lat:39.965577
        },
        {
          id: 1,
          name: "上海",
          address: "上海市长宁区临新路268弄5号楼B115，B116室",
          iphone: "400-603-0166",
          companyName: "上海位来小猎科技有限公司",
          title: "上海",
          route:'',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_shaihai%402x.png",
          lng:121.356277,
          lat:31.239426
        },
        {
          id: 2,
          name: "深圳",
          address: "深圳市福田区福田街道福山社区滨河大道5022号联合广场A座55F01B",
          iphone: "400-603-0166",
          companyName: "深圳位来小猎科技有限公司 ",
          title: "深圳",
          route:'',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_shenzhen%402x.png",
          lng:114.075386,
          lat:22.535441
        },
        {
          id: 3,
          name: "杭州",
          address: "浙江省杭州市滨江区长河街道长河路590号4幢3楼C8室",
          iphone: "400-603-0166",
          companyName: "杭州位来小猎科技有限公司 ",
          title: "杭州",
          route:'',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_hangzhou%402x.png",
          lng:120.203604,
          lat:30.19434
        },
        {
          id: 4,
          name: "宁波",
          address: "浙江省宁波市江北区长兴路715号8-1-4",
          iphone: "400-603-0166",
          companyName: "宁波位来小猎科技有限公司 ",
          title: "宁波",
          route:'',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_ningbo%402x.png",
          lng:121.475865,
          lat:29.951494
        },
        {
          id: 5,
          name: "西安",
          address: "陕西省西安市高新区高新六路cross万象汇2号楼1505",
          iphone: "400-603-0166",
          companyName: "西安位来小猎科技有限公司 ",
          title: "西安",
          route:'',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_xian%402x.png",
          lng:108.884077,
          lat:34.233512
        },
        {
          id: 6,
          name: "大连",
          address: "辽宁省大连市甘井子区春田园C-1号401K-43(大连中美智创孵化器有限公司区域内)",
          iphone: "400-603-0166",
          companyName: "大连位来小猎科技有限公司 ",
          title: "大连",
          route:'',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_dalian%402x.png",
          lng:121.465872,
          lat:38.974702
        },
        {
          id: 7,
          name: "咸阳",
          address: "陕西省咸阳市秦都区文兴路169号中创悦.丝路产业园3号楼",
          iphone: "400-603-0166",
          companyName: "咸阳位来小猎科技有限公司 ",
          title: "咸阳",
          route:'',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_xianyang%402x.png",
          lng:108.643219,
          lat:34.349718
        },
        {
          id: 8,
          name: "邯郸",
          address: "河北省邯郸市丛台区人民东路与土山街交叉口友谊时代广场A座1010号",
          iphone: "400-603-0166",
          companyName: "邯郸位来小猎科技有限公司 ",
          title: "邯郸",
          route:'',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_handan%402x.png",
          lng:114.498016,
          lat:36.616266
        },
        {
          id: 9,
          name: "青岛",
          address: "青岛市黄岛区长江中路汇商国际大厦B座2103室",
          iphone: "400-603-0166",
          companyName: "青岛位来小猎科技有限公司 ",
          title: "青岛",
          route:'',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_qingdao%402x.png",
          lng:120.191646,
          lat:35.959753
        },
        {
          id: 10,
          name: "桂林",
          address: "桂林市七星区上关村20栋",
          iphone: "400-603-0166",
          companyName: "桂林位来小猎科技有限公司 ",
          title: "桂林",
          route:'',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_guilin%402x.png",
          lng:110.313211,
          lat:25.29839
        },
         {
          id: 11,
          name: "达州",
          address: "四川省万源市秦川大道69号A栋8-5室",
          iphone: "400-603-0166",
          companyName: "达州位来小猎科技有限公司 ",
          title: "达州",
          route:'',
          img:"https://yilie.oss-cn-beijing.aliyuncs.com/web-common-assets/ats-speed-version/imgs/wlxl-web/wlxl-web/pic_bg_dazhou%402x.png",
          lng:108.045934,
          lat:32.081183
        },
      ],
      honorList:[
        {
          imgurl:'https://images.36w.cn/officialWebImagse/pic_certificate02@3x.png',
          name:'高新证书'
        },
        {
          imgurl:'https://images.36w.cn/officialWebImagse/pic_certificate01@3x.png',
          name:'ICP许可证'
        },
        {
          imgurl:'https://images.36w.cn/officialWebImagse/pic_certificate03@3x.png',
          name:'人力资源证'
        },
        {
          imgurl:'https://images.36w.cn/officialWebImagse/pic_certificate04@3x.png',
          name:'派遣证'
        },
        {
          imgurl:'https://images.36w.cn/officialWebImagse/pic_certificate05@3x.png',
          name:'最佳合作伙伴'
        },
        {
          imgurl:'https://images.36w.cn/officialWebImagse/pic_certificate06@3x.png',
          name:'滴滴招聘奖杯'
        },
        {
          imgurl:'https://images.36w.cn/officialWebImagse/pic_certificate07@3x.png',
          name:'最佳供应商'
        },
        {
          imgurl:'https://images.36w.cn/officialWebImagse/pic_certificate08@3x.png',
          name:'位来小猎名企奖'
        }
      ]
    };
  },
  components:{
    bdmap
  },
  created() {
   
  },
  mounted() {
	  this.$nextTick(()=>{this.toLocal()})
    var mySwiper = new Swiper(".swiper-container", {
      direction: "horizontal",
      loop: true,
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      slidesPerView: "auto",
      centeredSlides: true,
      //spaceBetween: 10,
      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }, 
    });
    let _this=this;
    _this.$nextTick(function(){
        window.addEventListener('scroll',_this.handleScroll)
    })	
  },
  methods: {
    contactusNav(a) {
      this.contactusActive = a;
      this.name=this.cityData[a].companyName;
      this.address=this.cityData[a].address;
      this.iphone=this.cityData[a].iphone;
      this.lng=this.cityData[a].lng;
      this.lat=this.cityData[a].lat;
      this.mapimg=this.cityData[a].img;
    },
    toLocal(){
		//查找存储的锚点id
		//let Id=localStorage.getItem('toId');
    var Id=this.$route.params.val;
		let toElement=document.getElementById(Id);
   
		//锚点存在跳转
		if(Id){
			toElement.scrollIntoView()
		}
	}
  },
  
  //用完后记得将存储的锚点置空，否则会影响其他页面跳转到当前页面
  destroyed() {
    localStorage.setItem('toId','');
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
.about {
  margin-top: 119px;
  .photo {
    width: 100%;
    height: 737px;
    background-color: #d8d8d8;
    img{
      width: 100%;
      height: 100%;
    }
  }
  @keyframes upAnimation {
			0%,
			100%,
			20%,
			50%,
			80% {
				transition-timing-function: cubic-bezier(0.215, .61, .355, 1);
				transform: translate3d(0, 0, 0);
			}

			40%,
			43% {
				transition-timing-function: cubic-bezier(0.755, 0.50, 0.855, 0.060);
				transform: translate3d(0, -30px, 0);
			}

			70% {
				transition-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
				transform: translate3d(0, -15px, 0);
			}
			90% {
				transform: translate3d(0, -4px, 0);
			}
		}
  .companyProfile_outer {
    .companyProfile {
      height: 969px;
      position: relative;
      .animated{
          animation-duration: 6s;
          /*动画时间*/
          animation-fill-mode: both;
          /*播放后的状态*/
          animation-iteration-count: infinite;
          /*动作循环的次数：infinite 无限循环*/
      }
      .img1{
        position: absolute;
        width: 95px;
        height: 140px;
        left: 0;
        top: 63px;
        animation-name: upAnimation;
        /*动画的名称*/
        transform-origin: center bottom;
        /*设置动画旋转元素的基点为*/
        cursor: pointer;
      }
      .img2{
        position: absolute;
        width: 115px;
        height: 160px;
        right: 0;
        top: 536px;
        animation-name: upAnimation;
        /*动画的名称*/
        transform-origin: center bottom;
        /*设置动画旋转元素的基点为*/
        cursor: pointer;
      }
      .companyProfileContent {
        width: 1200px;
        height: 599px;
        margin: 122px auto 0;
        position: relative;
        .companyProfileContentImg {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 565px;
          height: 599px;
          background:url("https://images.36w.cn/officialWebImagse/pic_thecompany_photos@3x.png");
          background-size: 565px 599px;
        }
        .companyProfileContentText {
          position: absolute;
          left: 380px;
          top: 34px;
          z-index: 3;
          width: 822px;
          height: 530px;
          background-color: #ffffff;
          box-shadow: 0px 2px 33px 0px #d5d7e4;
          border-radius: 3px;
          .textContent {
            width: 739px;
            height: 418px;
            font-size: 18px;
            line-height: 35px;
            letter-spacing: 0px;
            color: #324148;
            margin: 56px auto;
            .paragraph {
              font-size: 18px;
              line-height: 35px;
              color: #324148;
              p {
                text-indent: 32px;
              }
            }
            .paragraphUp {
              padding-bottom: 34px;
            }
          }
        }
      }
      .companyProfileContent:after {
        content: "";
        position: absolute;
        left: -63px;
        top: -45px;
        width: 190px;
        height: 193px;
        background-color: #4970fb;
      }
      .companyProfileContent:before {
        content: "";
        position: absolute;
        left: -29px;
        bottom: 0;
        width: 29px;
        height: 80px;
        background-color: #fa8d44;
      }
    }
  }
  .vision_outer {
    background-color: #f6f9ff;
    .vision {
      padding-top: 87px;
      height: 571px;
      .vision_modular {
        margin-bottom: 40px;
        h4 {
          height: 45px;
          line-height: 45px;
          font-size: 32px;
          color: #333333;
          text-align: center;
          font-weight: 600;
        }
        p {
          margin-top: 6px;
          height: 49px;
          font-size: 26px;
          line-height: 49px;
          text-align: center;
          color: #333333;
        }
      }
    }
  }
  .developmentHistory_outer {
    background: url("https://images.36w.cn/officialWebImagse/about/pic_img02@2x.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .developmentHistory {
      height: 1151px;
      // background-image: linear-gradient(
      //   36deg,
      //   #71b7f2 0%,
      //   #71b7f2 8%,
      //   #4970fb 100%
      // );
      .developmentHistoryContent {
        display: flex;
        justify-content: center;
        margin-top: 50px;
        .contentLeft,
        .contentRight {
          width: 399px;
          font-size: 20px;
          height: 779px;
          // background:#f00;
        }

        .record {
          // padding-top:2px;
          padding-right: 38px;
          text-align: right;
          font-size: 20px;
          color: #ffffff;
          h4 {
            width: 292px;
            text-align: left;
            font-size: 24px;
            padding-left: 188px;
          }
        }

        .contentRight {
          .record {
            padding-right: 0;
            text-align: left;
            padding-left: 40px;
          }
          h4 {
            padding-left: 0;
          }
        }

        .contentCenter-timeAxis {
          margin: 12px 0 0;
          width: 20px;
          height: 779px;
          position: relative;
          overflow: hidden;
          li {
            width: 20px;
            height: 20px;
            background-color: rgba(255, 255, 255, 0.47);
            margin-bottom: 42px;
            border-radius: 50%;
            position: relative;
            z-index: 2;
            position: relative;
            span {
              display: inline-block;
              width: 10px;
              height: 10px;
              background-color: #ffffff;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border-radius: 50%;
            }
          }
          li:first-child {
            margin-top: 27px;
          }
          // li:nth-child(5) {
          //   margin-bottom: 73px;
          // }
        }
        .contentCenter-timeAxis:after {
          content: "";
          width: 2px;
          display: block;
          height: 779px;
          z-index: 1;
          background-color: #e6e9ef;
          position: absolute;
          left: 50%;
          top: 0;
          margin-left: -1px;
        }
      }
    }
  }
  .authentication_outer {
    .authentication {
      height: 1041px;
      .authenticationContent {
        padding-top: 113px;
        ul {
          width: 1450px;
          li {
            width: 280px;
            height: 267px;
            margin: 0 25px 84px 0;
            float: left;
            border-left: solid 1px #f1f1f1;
            border-top:  solid 1px #f1f1f1;
            background-color: #fdfdfb;
            box-shadow: 0px 30px 65px 0px 
		rgba(140, 153, 191, 0.2);
            .honorbox{
              widows: 250px;
              height: 207px;
              padding-left: 10px;
              padding-right: 10px;
              padding-top: 2px;
              img{
                width: 100%;
                height: 100%;
              }
              p{
                font-size: 20px;
                color: #4e4e4e;
                text-align: center;
                margin-top: 17px;
              }
            }
          }
        }
      }
    }
  }
  .staff_outer {
    background-image: url("https://images.36w.cn/officialWebImagse/about/pic_staff presence@2x-2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 1037px;
    .swiper-container {
      margin-top: 124px;
      height: 690px;
      margin-bottom: 53px;
    }
    .swiper-slide {
      position: relative;
      width: 901px !important;
      height: 628px;
      border-radius: 10px;
      align-content: center;
      margin-left: 35px;
      margin-right: 35px;
      padding-top: 32px;
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 90px;
      img{
        width: 100%;
        height: 100%;
      }
      span{
        position: absolute;
        font-size: 18px;
        color: #666666;
        left: 50%;
        bottom: 37px;
        transform: translateX(-50%);
      }
    }
    .swiper-container .swiper-wrapper .swiper-slide-prev {
      margin-top: 54px;
      margin-bottom: 110px;
      height: 528px !important;
    }
   
    .swiper-container .swiper-wrapper .swiper-slide-next {
      margin-top: 54px;
      margin-bottom: 110px;
      height: 528px !important;
    }
   
    .swiper-container .swiper-wrapper .swiper-slide-active {
      width: 620px;
    }
    .borderbox{
      position: relative;
      width: 100%;
      height: 30px;
    }
    .swiper-pagination {
     position:absolute;
                bottom: 15px;
                left:50% !important;
                transform:translateX(-50%);
                /deep/ .swiper-pagination-bullet{
                    margin-left:10px;
                }
    }
    // .swiper-pagination .swiper-pagination-bullet {
    //   width: 51px;
    //   height: 12px;
    //   background: #ff1e1e;
    // }
    // .swiper-pagination .swiper-pagination-bullet-active {
    //   width: 21px;
    //   height: 12px;
    //   background: #e75230;
    //   border-radius: 6px;
    // }
  }
  .contactus_outer {
    .contactus {
      height: 903px;
      .contactusContent {
        .nav_ul {
          padding-top: 67px;
          width: 1200px;
          margin: 0 auto;
          li {
            width: 170px;
            height: 72px;
            cursor: pointer;

            border-radius: 59px;
            float: left;

            font-size: 24px;
            color: #333333;
            text-align: center;
            line-height: 72px;
          }
          li.contactusAcitve {
            background-color: #4970fb;
            box-shadow: 0px 4px 16px 0px #b3b3b3;
            color: #fff;
          }
        }
        .content_ul {
          margin: 0 auto;
          margin-top: 46px;
          width: 1200px;
          li {
            .content_ul_map {
              width: 1248px;
              height: 342px;
              background-color: #d8d8d8;
            }
            .content_ul_text {
              height: 269px;
              padding-top: 99px;
              h3 {
                font-size: 26px;
                line-height: 37px;
                color: #333333;
              }
              p {
                padding-top: 24px;
                font-size: 20px;
                line-height: 36px;
                color: #333333;
                span {
                  display: inline-block;
                  padding-left: 73px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/about/index.vue